<template lang="html">
  <div id="contact-page">

    <section class="placed-backg banner-section">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-6 col-xl-5 col-titles">
            <h1 class="mb-3 title">{{ $t("contact.title") }}</h1>

            <h6 class="title-sl-1"><span>{{ $t("contact.subtitle") }}</span></h6>
          </div>

          <div class="col-lg-5 col-xl-4 col-info">
            <p>
              {{ $t("contact.description") }}<br>
              {{ $t("contact.description_two") }}
            </p>
          </div>

          <div class="col-lg-1 col-xl-2 col-bg">
            <div class="bg-color"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="placed-backg img-banner-section" v-bind:style="{ backgroundImage: 'url(public/images/pages/contact/banner-2.jpg)' }">
    </section>

    <section class="container oversized-container thanks-section">
      <div class="row">
        <div class="col-lg-5 col-title">
          <h2 class="title">{{ $t("contact.thankyou") }}</h2>
        </div>

        <div class="col-lg-7 col-info">
          <p>
            {{ $t("contact.info_one") }}<br>
            <br>
            {{ $t("contact.info_two") }}<br>
            <br>
            {{ $t("contact.info_three") }} <a class="f-w-600" href="#">{{ $t("contact.here") }}</a>.
          </p>
        </div>
      </div>
    </section>

    <section class="container oversized-container form-section">
      <b-form class="row justify-content-center" @submit="onSubmit">
        <div class="col-lg-4 mb-2">
          <b-form-group class="custom-f-group-2"
          :label='$t("contact.form.name")'>
            <b-form-input
              v-model="form.name"
              type="text"
              size="lg"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-lg-4 mb-2">
          <b-form-group class="custom-f-group-2"
          :label='$t("contact.form.lastname")'>
            <b-form-input
              v-model="form.lastName"
              type="text"
              size="lg"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-12"></div>

        <div class="col-lg-4 mb-2">
          <b-form-group class="custom-f-group-2"
          :label='$t("contact.form.phone")'>
            <b-form-input
              v-model="form.phone"
              type="number"
              size="lg"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-lg-4 mb-2">
          <b-form-group class="custom-f-group-2"
          :label='$t("contact.form.email")'>
            <b-form-input
              v-model="form.email"
              type="email"
              size="lg"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-12"></div>

        <div class="col-lg-8 mb-2">
          <b-form-group class="custom-f-group-2"
          :label='$t("contact.form.comments")'>
            <b-form-textarea
              v-model="form.comments"
              placeholder=""
              rows="3"
              max-rows="3"
              required
            ></b-form-textarea>
          </b-form-group>
        </div>

        <div class="col-5" style="background-color: black;"></div>
        <div class="col-8">

          <vue-recaptcha
            sitekey="6LcaE4okAAAAAFYKGFfWc9wbF0IXRcRBzSzZmiyw"
            ref="recaptcha"
            @verify="handleSuccess"
            >
          </vue-recaptcha>
        </div>

        <div class="col-12 text-center">
          <b-button type="submit" class="btn-s1 blue btn-bg">{{ $t("contact.form.submit") }}</b-button>
        </div>
      </b-form>

      <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div v-html="modal.msg"></div>
      </sweet-modal>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: null,
        lastName: null,
        phone: null,
        email: null,
        comments: null,
      },
      recaptchaVerified:false,
      modal:{
        msg:'',
        icon:'',
        block:false,
      },
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      })
    },

    onSubmit(evt) {
      evt.preventDefault();
      if(this.recaptchaVerified == true){

        this.modal.block = true;
        this.modal.icon = "";
        this.modal.msg = "Loading...";
        this.$refs.modal.open();

        var params = this.form;
        var apiURL = tools.url("/api/contact");

        axios.post( apiURL,params )
        .then( (response) => {
          // alert(response.data.response);
          this.makeToast('success', response.data.response, 'Message sent');
          // alert(response.data.response);

          for (let prop in this.form) {
            this.form[prop] = '';
          }
          this.modal.block = false;
          this.modal.icon = "success";
          this.modal.msg = "Thank you for contacting us! We will get back to you as soon as possible.";
        })
        .catch( (error) => {
          // console.log(error.response.data);
          let errors = error.response.data;

          for (let prop in errors) {
            // console.log(errors[prop]);
            this.makeToast('danger', errors[prop], '¡Error!');
          }
          this.modal.block = false;
          this.modal.icon = "error";
          this.modal.msg = "Error saving information";
        });
      }else{
        this.modal.block = false;
          this.modal.icon = "warning";
          this.modal.msg = "Complete the captcha";
          this.$refs.modal.open();
      }
    },

    handleSuccess(response) {
      this.recaptchaVerified = true;
    }
  },
}
</script>
